/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_APPS_PERFORMANCE_RESPONSE = {
	title: "My running Apps - CO2e Emissions",
	lineSeries: [
		{
			name: "allApps",
			linePoints: [
				{
					name: "2026-04-01T00:00:00.000Z",
					value: 0.99296472045136852,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T01:00:00.000Z",
					value: 0.96281239747047276,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T02:00:00.000Z",
					value: 0.95846128176358825,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T03:00:00.000Z",
					value: 0.97851923582153111,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T04:00:00.000Z",
					value: 0.990658271823676,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T05:00:00.000Z",
					value: 0.69320281580132681,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T06:00:00.000Z",
					value: 0.86200654173173985,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T07:00:00.000Z",
					value: 1.6032358111729017,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T08:00:00.000Z",
					value: 0.97441124304688986,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T09:00:00.000Z",
					value: 0.90799698455833688,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T10:00:00.000Z",
					value: 0.86662900757607986,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T11:00:00.000Z",
					value: 0.97723655602222526,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T12:00:00.000Z",
					value: 0.81684933221204648,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T13:00:00.000Z",
					value: 0.84542542699121426,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T14:00:00.000Z",
					value: 0.99356642649168414,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T15:00:00.000Z",
					value: 1.6540505025767254,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T16:00:00.000Z",
					value: 1.0035560641695949,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T17:00:00.000Z",
					value: 0.92508406893316,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T18:00:00.000Z",
					value: 0.85299286171891409,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T19:00:00.000Z",
					value: 0.95600896648344591,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T20:00:00.000Z",
					value: 0.99258106620489339,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T21:00:00.000Z",
					value: 0.81598881154475011,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T22:00:00.000Z",
					value: 0.60180949358185976,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-01T23:00:00.000Z",
					value: 1.4773741830657057,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T00:00:00.000Z",
					value: 0.979058718830179,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T01:00:00.000Z",
					value: 0.87786767086072626,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T02:00:00.000Z",
					value: 0.97855689506178056,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T03:00:00.000Z",
					value: 0.975906561302723,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T04:00:00.000Z",
					value: 0.9803534449611645,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T05:00:00.000Z",
					value: 0.9819237208838848,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T06:00:00.000Z",
					value: 0.98849449646436394,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T07:00:00.000Z",
					value: 1.7907471804657524,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T08:00:00.000Z",
					value: 0.98993245599015878,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T09:00:00.000Z",
					value: 0.98213229917508715,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T10:00:00.000Z",
					value: 0.83665069350010446,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T11:00:00.000Z",
					value: 0.64000325294805238,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T12:00:00.000Z",
					value: 0.90917016513458659,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T13:00:00.000Z",
					value: 0.95170912558697585,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T14:00:00.000Z",
					value: 0.957065809322944,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T15:00:00.000Z",
					value: 1.5455854425907243,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T16:00:00.000Z",
					value: 0.97708652594057133,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T17:00:00.000Z",
					value: 0.84276025506248309,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T18:00:00.000Z",
					value: 0.97764732528616627,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T19:00:00.000Z",
					value: 0.95488842418875985,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T20:00:00.000Z",
					value: 0.95700756703276046,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T21:00:00.000Z",
					value: 0.98057490734063235,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T22:00:00.000Z",
					value: 0.84452617409130237,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-02T23:00:00.000Z",
					value: 1.8331243538210344,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T00:00:00.000Z",
					value: 0.97157895824395646,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T01:00:00.000Z",
					value: 0.95819758276860956,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T02:00:00.000Z",
					value: 1.0050349732943387,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T03:00:00.000Z",
					value: 0.95736422484583128,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T04:00:00.000Z",
					value: 0.97242709292167417,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T05:00:00.000Z",
					value: 0.96956253220170774,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T06:00:00.000Z",
					value: 0.98040284480444262,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T07:00:00.000Z",
					value: 1.6728233674182809,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T08:00:00.000Z",
					value: 0.61825353396086047,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T09:00:00.000Z",
					value: 0.93477093024113322,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T10:00:00.000Z",
					value: 0.98774098596137172,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T11:00:00.000Z",
					value: 0.98111878247006146,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T12:00:00.000Z",
					value: 0.88719937398019177,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T13:00:00.000Z",
					value: 0.98981456647280608,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T14:00:00.000Z",
					value: 0.932803831825569,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T15:00:00.000Z",
					value: 1.8265445983918227,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T16:00:00.000Z",
					value: 0.78666866446985662,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T17:00:00.000Z",
					value: 0.89513260187812982,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T18:00:00.000Z",
					value: 0.98082269033729474,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T19:00:00.000Z",
					value: 0.64722247209181727,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T20:00:00.000Z",
					value: 0.99897338427341742,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T21:00:00.000Z",
					value: 0.98352056276465771,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T22:00:00.000Z",
					value: 0.97159057464053189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-03T23:00:00.000Z",
					value: 1.2622436494765481,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T00:00:00.000Z",
					value: 0.98177510033727189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T01:00:00.000Z",
					value: 0.50830890672236761,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T02:00:00.000Z",
					value: 0.804751805050623,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T03:00:00.000Z",
					value: 0.95417025087523277,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T04:00:00.000Z",
					value: 0.97714731107265751,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T05:00:00.000Z",
					value: 0.95309180567194007,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T06:00:00.000Z",
					value: 0.68950554672378428,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T07:00:00.000Z",
					value: 1.6433179524317625,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T08:00:00.000Z",
					value: 0.87189413746275823,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T09:00:00.000Z",
					value: 0.90227583760963814,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T10:00:00.000Z",
					value: 0.88139593782574,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T11:00:00.000Z",
					value: 0.88840611371986355,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T12:00:00.000Z",
					value: 0.59959492569810857,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T13:00:00.000Z",
					value: 0.97739369076946614,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T14:00:00.000Z",
					value: 0.93025417873709126,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T15:00:00.000Z",
					value: 1.6534725064424132,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T16:00:00.000Z",
					value: 0.980125649082517,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T17:00:00.000Z",
					value: 0.97854638956490647,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T18:00:00.000Z",
					value: 1.0024254119334504,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T19:00:00.000Z",
					value: 0.98863634316696614,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T20:00:00.000Z",
					value: 0.96370522972038231,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T21:00:00.000Z",
					value: 0.97143927083072523,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T22:00:00.000Z",
					value: 0.83593134805279745,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-04T23:00:00.000Z",
					value: 1.800898606149276,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T00:00:00.000Z",
					value: 0.96357093683837358,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T01:00:00.000Z",
					value: 0.98764651492093247,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T02:00:00.000Z",
					value: 0.97017023325753637,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T03:00:00.000Z",
					value: 0.963042540922154,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T04:00:00.000Z",
					value: 0.9876859883422705,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T05:00:00.000Z",
					value: 0.98088815368084237,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T06:00:00.000Z",
					value: 0.98744319934192393,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T07:00:00.000Z",
					value: 1.7939116727138127,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T08:00:00.000Z",
					value: 0.84876035196230715,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T09:00:00.000Z",
					value: 0.873891523000762,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T10:00:00.000Z",
					value: 0.99053923809363709,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T11:00:00.000Z",
					value: 0.98393738026894584,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T12:00:00.000Z",
					value: 0.96706786588697424,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T13:00:00.000Z",
					value: 0.98709664854244228,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T14:00:00.000Z",
					value: 0.64394692647708462,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T15:00:00.000Z",
					value: 1.8120258796152493,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T16:00:00.000Z",
					value: 0.98090192402637277,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T17:00:00.000Z",
					value: 0.99440228937165487,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T18:00:00.000Z",
					value: 0.97518881922076261,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T19:00:00.000Z",
					value: 0.88761287700193958,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T20:00:00.000Z",
					value: 0.9715622702579455,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T21:00:00.000Z",
					value: 0.97775697712327214,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T22:00:00.000Z",
					value: 0.86127125037130381,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-05T23:00:00.000Z",
					value: 1.8108212705971189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T00:00:00.000Z",
					value: 0.99840683325694934,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T01:00:00.000Z",
					value: 0.97192183501180485,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T02:00:00.000Z",
					value: 0.99476878487422959,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T03:00:00.000Z",
					value: 0.96564520335185933,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T04:00:00.000Z",
					value: 0.98543621191063235,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T05:00:00.000Z",
					value: 0.97130752594736469,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T06:00:00.000Z",
					value: 0.96026089339016107,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T07:00:00.000Z",
					value: 1.6804579153465473,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T08:00:00.000Z",
					value: 0.96969675646540243,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T09:00:00.000Z",
					value: 0.45187846383175939,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T10:00:00.000Z",
					value: 0.97633031890328237,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T11:00:00.000Z",
					value: 0.88500968144033665,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T12:00:00.000Z",
					value: 0.98016500841560661,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T13:00:00.000Z",
					value: 0.90616303744000537,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T14:00:00.000Z",
					value: 0.98947566883871341,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T15:00:00.000Z",
					value: 1.7983211165643538,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T16:00:00.000Z",
					value: 0.76684603388485817,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T17:00:00.000Z",
					value: 0.96758627317047941,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T18:00:00.000Z",
					value: 0.77780344203091623,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T19:00:00.000Z",
					value: 0.97999995452742239,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T20:00:00.000Z",
					value: 0.44315730306372247,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T21:00:00.000Z",
					value: 0.973706202226786,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T22:00:00.000Z",
					value: 0.88008332662352529,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-06T23:00:00.000Z",
					value: 1.5184028209041749,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T00:00:00.000Z",
					value: 0.97869997857267266,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T01:00:00.000Z",
					value: 0.869883856746396,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T02:00:00.000Z",
					value: 0.99946090031829093,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T03:00:00.000Z",
					value: 0.99889785777340045,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T04:00:00.000Z",
					value: 0.85613527483886742,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T05:00:00.000Z",
					value: 0.9897395775419654,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T06:00:00.000Z",
					value: 0.99650368930194877,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T07:00:00.000Z",
					value: 1.7920708845592446,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T08:00:00.000Z",
					value: 0.93150995190335839,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T09:00:00.000Z",
					value: 0.99294351730788377,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T10:00:00.000Z",
					value: 0.98213106898374047,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T11:00:00.000Z",
					value: 0.9801058695056315,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T12:00:00.000Z",
					value: 0.44027794090041578,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T13:00:00.000Z",
					value: 0.79007003767050021,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T14:00:00.000Z",
					value: 1.0069664062020225,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T15:00:00.000Z",
					value: 1.566274499745111,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T16:00:00.000Z",
					value: 0.86412081019767406,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T17:00:00.000Z",
					value: 0.98467322288388559,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T18:00:00.000Z",
					value: 0.87653118785500461,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T19:00:00.000Z",
					value: 0.4804646157356347,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T20:00:00.000Z",
					value: 0.987678497721597,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T21:00:00.000Z",
					value: 0.986905361451551,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T22:00:00.000Z",
					value: 0.970349764735478,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-07T23:00:00.000Z",
					value: 1.2443195253238188,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T00:00:00.000Z",
					value: 0.86353320777308373,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T01:00:00.000Z",
					value: 0.9703881982154674,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T02:00:00.000Z",
					value: 0.9347996485937492,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T03:00:00.000Z",
					value: 0.9856791748527064,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T04:00:00.000Z",
					value: 1.0026834676003658,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T05:00:00.000Z",
					value: 0.99300685533172661,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T06:00:00.000Z",
					value: 0.93532559283372885,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T07:00:00.000Z",
					value: 1.6262362957375915,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T08:00:00.000Z",
					value: 0.96040319988680389,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T09:00:00.000Z",
					value: 0.98647335992101093,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T10:00:00.000Z",
					value: 0.66772110251287031,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T11:00:00.000Z",
					value: 0.91738000410485776,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T12:00:00.000Z",
					value: 0.89220579223250518,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T13:00:00.000Z",
					value: 0.86778935763142706,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T14:00:00.000Z",
					value: 0.80127070945072432,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T15:00:00.000Z",
					value: 1.6016440651529256,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T16:00:00.000Z",
					value: 0.98925816211899076,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T17:00:00.000Z",
					value: 0.97651013181556734,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T18:00:00.000Z",
					value: 0.85819292198886243,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T19:00:00.000Z",
					value: 0.83071328390790833,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T20:00:00.000Z",
					value: 0.94206291742013415,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T21:00:00.000Z",
					value: 0.8592736570552485,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T22:00:00.000Z",
					value: 0.85286748869990858,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-08T23:00:00.000Z",
					value: 1.6509603329258387,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T00:00:00.000Z",
					value: 0.97969862696648391,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T01:00:00.000Z",
					value: 0.96104349884448581,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T02:00:00.000Z",
					value: 0.99160336968918183,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T03:00:00.000Z",
					value: 0.84464392140473288,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T04:00:00.000Z",
					value: 0.98205158998108288,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T05:00:00.000Z",
					value: 0.97216848824461133,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T06:00:00.000Z",
					value: 0.73332037703752873,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T07:00:00.000Z",
					value: 1.8160753010291246,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T08:00:00.000Z",
					value: 0.83306226460266841,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T09:00:00.000Z",
					value: 0.80906251717064515,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T10:00:00.000Z",
					value: 0.97826064696005777,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T11:00:00.000Z",
					value: 0.8852800509388018,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T12:00:00.000Z",
					value: 0.86934418027732718,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T13:00:00.000Z",
					value: 0.57956777108415014,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T14:00:00.000Z",
					value: 0.79571917318745877,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T15:00:00.000Z",
					value: 1.7017876121237969,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T16:00:00.000Z",
					value: 0.86308242202823515,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T17:00:00.000Z",
					value: 0.90432688391860938,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T18:00:00.000Z",
					value: 0.92580403975077052,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T19:00:00.000Z",
					value: 0.9799118178787648,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T20:00:00.000Z",
					value: 0.49384552086042877,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T21:00:00.000Z",
					value: 0.86216031344554755,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T22:00:00.000Z",
					value: 0.94688804389734516,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-09T23:00:00.000Z",
					value: 1.4504941419825053,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T00:00:00.000Z",
					value: 0.96705409111460194,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T01:00:00.000Z",
					value: 0.811568446343339,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T02:00:00.000Z",
					value: 0.70997416517907153,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T03:00:00.000Z",
					value: 0.88472650624795868,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T04:00:00.000Z",
					value: 0.96044646542209988,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T05:00:00.000Z",
					value: 0.90132233358102654,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T06:00:00.000Z",
					value: 0.53980381794620313,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T07:00:00.000Z",
					value: 1.7075494856343369,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T08:00:00.000Z",
					value: 0.40401396679453727,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T09:00:00.000Z",
					value: 0.98058556292981258,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T10:00:00.000Z",
					value: 0.851260695691773,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T11:00:00.000Z",
					value: 0.73172725632821334,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T12:00:00.000Z",
					value: 0.88169255069966734,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T13:00:00.000Z",
					value: 0.95626575067531239,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T14:00:00.000Z",
					value: 0.9805646970824784,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T15:00:00.000Z",
					value: 1.8359590911961321,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T16:00:00.000Z",
					value: 0.79093495697668159,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T17:00:00.000Z",
					value: 0.91434652902077684,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T18:00:00.000Z",
					value: 0.75065053787343683,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T19:00:00.000Z",
					value: 0.92551663684134722,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T20:00:00.000Z",
					value: 0.86936564590653587,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T21:00:00.000Z",
					value: 0.52475505409386336,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T22:00:00.000Z",
					value: 0.48061739993322317,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-10T23:00:00.000Z",
					value: 1.2498824940991897,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T00:00:00.000Z",
					value: 0.85623395124468338,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T01:00:00.000Z",
					value: 0.89915483839187182,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T02:00:00.000Z",
					value: 0.5195163452796201,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T03:00:00.000Z",
					value: 0.96701658996767526,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T04:00:00.000Z",
					value: 0.65970969862431061,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T05:00:00.000Z",
					value: 0.82117631682116388,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T06:00:00.000Z",
					value: 0.87204048062738293,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T07:00:00.000Z",
					value: 1.2835052628298749,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T08:00:00.000Z",
					value: 0.852921236803993,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T09:00:00.000Z",
					value: 0.848060883211206,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T10:00:00.000Z",
					value: 0.96484152125530143,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T11:00:00.000Z",
					value: 0.73239150968693867,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T12:00:00.000Z",
					value: 0.84082332899793033,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T13:00:00.000Z",
					value: 0.89205990556137293,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T14:00:00.000Z",
					value: 0.8147722154881295,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T15:00:00.000Z",
					value: 1.70631918128558,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T16:00:00.000Z",
					value: 0.68092293830464234,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T17:00:00.000Z",
					value: 0.75634123074110871,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T18:00:00.000Z",
					value: 0.47080955541113167,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T19:00:00.000Z",
					value: 0.868262069737215,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T20:00:00.000Z",
					value: 0.59612618154408514,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T21:00:00.000Z",
					value: 0.94165996789549944,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T22:00:00.000Z",
					value: 0.88301160904713749,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-11T23:00:00.000Z",
					value: 1.4299798890231288,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T00:00:00.000Z",
					value: 0.75621146251008442,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T01:00:00.000Z",
					value: 0.74491365364798223,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T02:00:00.000Z",
					value: 0.567172076909221,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T03:00:00.000Z",
					value: 0.54161580308871571,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T04:00:00.000Z",
					value: 0.98133147378282282,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T05:00:00.000Z",
					value: 0.80929578082794362,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T06:00:00.000Z",
					value: 0.663126558672793,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T07:00:00.000Z",
					value: 1.8049637910469225,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T08:00:00.000Z",
					value: 0.83616498313458831,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T09:00:00.000Z",
					value: 0.69810002677661065,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T10:00:00.000Z",
					value: 0.67832372777604355,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T11:00:00.000Z",
					value: 0.81633706790072735,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T12:00:00.000Z",
					value: 0.8497607430499059,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T13:00:00.000Z",
					value: 0.68881197188997212,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T14:00:00.000Z",
					value: 0.78693214416882162,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T15:00:00.000Z",
					value: 1.4727373265255719,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T16:00:00.000Z",
					value: 0.97268597891385444,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T17:00:00.000Z",
					value: 0.67234464764008894,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T18:00:00.000Z",
					value: 0.65073574087417863,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T19:00:00.000Z",
					value: 0.95505558512798738,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T20:00:00.000Z",
					value: 0.84093180934117706,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T21:00:00.000Z",
					value: 0.84522750601146757,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T22:00:00.000Z",
					value: 0.55786547489286953,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-12T23:00:00.000Z",
					value: 1.1835193898005192,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T00:00:00.000Z",
					value: 0.39968588729033244,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T01:00:00.000Z",
					value: 0.89991359963481132,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T02:00:00.000Z",
					value: 0.77611839173731023,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T03:00:00.000Z",
					value: 0.87781859854593469,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T04:00:00.000Z",
					value: 0.88512099998130744,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T05:00:00.000Z",
					value: 0.64298077430943268,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T06:00:00.000Z",
					value: 0.81664858820016706,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T07:00:00.000Z",
					value: 1.0496240024757975,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T08:00:00.000Z",
					value: 0.93975447974772686,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T09:00:00.000Z",
					value: 0.87650140041423985,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T10:00:00.000Z",
					value: 0.34531288278323014,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T11:00:00.000Z",
					value: 0.98510518824880666,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T12:00:00.000Z",
					value: 0.98682062310706664,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T13:00:00.000Z",
					value: 0.56471491706175725,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T14:00:00.000Z",
					value: 0.85015721291838464,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T15:00:00.000Z",
					value: 1.4590495330244257,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T16:00:00.000Z",
					value: 0.58671079895964151,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T17:00:00.000Z",
					value: 0.90023838539638767,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T18:00:00.000Z",
					value: 1.7935255969515511,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T19:00:00.000Z",
					value: 0.95855076572742914,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T20:00:00.000Z",
					value: 0.94355869011956861,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T21:00:00.000Z",
					value: 0.87737101297739872,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T22:00:00.000Z",
					value: 0.76782230530820628,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-13T23:00:00.000Z",
					value: 1.6178487136934818,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T00:00:00.000Z",
					value: 0.98387800652311208,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T01:00:00.000Z",
					value: 0.96920742563184892,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T02:00:00.000Z",
					value: 0.948752549649862,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T03:00:00.000Z",
					value: 0.42672484388317028,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T04:00:00.000Z",
					value: 0.83398897888285561,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T05:00:00.000Z",
					value: 0.68458250565453593,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T06:00:00.000Z",
					value: 0.97756535415330736,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T07:00:00.000Z",
					value: 1.6732811790412982,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T08:00:00.000Z",
					value: 0.98886943148936934,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T09:00:00.000Z",
					value: 0.79429795565516059,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T10:00:00.000Z",
					value: 0.97111970502778966,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T11:00:00.000Z",
					value: 0.97920849215649008,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T12:00:00.000Z",
					value: 0.88704994158483053,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T13:00:00.000Z",
					value: 0.98025118462198157,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T14:00:00.000Z",
					value: 0.98937238558442053,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T15:00:00.000Z",
					value: 1.2858050301632102,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T16:00:00.000Z",
					value: 0.97281018848349243,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T17:00:00.000Z",
					value: 0.96366599050575341,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T18:00:00.000Z",
					value: 0.9860031294882412,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T19:00:00.000Z",
					value: 1.0015118465537773,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T20:00:00.000Z",
					value: 0.97953136656608342,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T21:00:00.000Z",
					value: 0.98065345384335323,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T22:00:00.000Z",
					value: 0.849908029276687,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-14T23:00:00.000Z",
					value: 1.5411656472557189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T00:00:00.000Z",
					value: 0.82314200751422306,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T01:00:00.000Z",
					value: 0.90565554483871369,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T02:00:00.000Z",
					value: 0.77965005461400094,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T03:00:00.000Z",
					value: 0.92326750433605786,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T04:00:00.000Z",
					value: 0.87545498351698625,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T05:00:00.000Z",
					value: 0.98010740880549019,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T06:00:00.000Z",
					value: 0.86728350351734773,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T07:00:00.000Z",
					value: 1.2667969043809963,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T08:00:00.000Z",
					value: 0.870684494669993,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T09:00:00.000Z",
					value: 0.93881424287045556,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T10:00:00.000Z",
					value: 0.90378312720095366,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T11:00:00.000Z",
					value: 0.98670893709128693,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T12:00:00.000Z",
					value: 0.990895924975423,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T13:00:00.000Z",
					value: 0.97616912648271192,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T14:00:00.000Z",
					value: 0.8765741850020552,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T15:00:00.000Z",
					value: 1.68840534828573,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T16:00:00.000Z",
					value: 0.98728540950355348,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T17:00:00.000Z",
					value: 0.98294923061474637,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T18:00:00.000Z",
					value: 0.66979581674593169,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T19:00:00.000Z",
					value: 0.9810432021173493,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T20:00:00.000Z",
					value: 0.76932467488304568,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T21:00:00.000Z",
					value: 0.88674806044081189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T22:00:00.000Z",
					value: 0.9509178621280383,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-15T23:00:00.000Z",
					value: 1.8205487985368309,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T00:00:00.000Z",
					value: 0.99913036138740619,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T01:00:00.000Z",
					value: 0.94886381467250114,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T02:00:00.000Z",
					value: 0.92506466476274474,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T03:00:00.000Z",
					value: 0.97746847701036987,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T04:00:00.000Z",
					value: 0.97384537327320975,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T05:00:00.000Z",
					value: 1.0088416873580126,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T06:00:00.000Z",
					value: 0.91187329776500281,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T07:00:00.000Z",
					value: 1.8308644324819574,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T08:00:00.000Z",
					value: 0.87674633281465431,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T09:00:00.000Z",
					value: 0.827060991356117,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T10:00:00.000Z",
					value: 0.76189675191846817,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T11:00:00.000Z",
					value: 0.97211000151238947,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T12:00:00.000Z",
					value: 0.644710664715597,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T13:00:00.000Z",
					value: 0.76278704316676338,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T14:00:00.000Z",
					value: 0.88049614855647407,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T15:00:00.000Z",
					value: 1.5911594379839671,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T16:00:00.000Z",
					value: 0.99646342504124563,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T17:00:00.000Z",
					value: 1.0062677135397473,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T18:00:00.000Z",
					value: 0.47943542635752917,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T19:00:00.000Z",
					value: 0.61749739590738328,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T20:00:00.000Z",
					value: 0.98317783932310321,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T21:00:00.000Z",
					value: 0.98964736665402209,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T22:00:00.000Z",
					value: 0.81803918522121866,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-16T23:00:00.000Z",
					value: 1.5466819899070881,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T00:00:00.000Z",
					value: 0.96980970447309089,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T01:00:00.000Z",
					value: 0.846117989731506,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T02:00:00.000Z",
					value: 0.86995439081817216,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T03:00:00.000Z",
					value: 0.81794237807471337,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T04:00:00.000Z",
					value: 0.99099927304408875,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T05:00:00.000Z",
					value: 0.93053591902453014,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T06:00:00.000Z",
					value: 0.91797142687538158,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T07:00:00.000Z",
					value: 1.6473196502874941,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T08:00:00.000Z",
					value: 0.97585628094020993,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T09:00:00.000Z",
					value: 0.79700567469994088,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T10:00:00.000Z",
					value: 0.81827322729293306,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T11:00:00.000Z",
					value: 0.89561450822024591,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T12:00:00.000Z",
					value: 0.95558894160950825,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T13:00:00.000Z",
					value: 0.61400100554072423,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T14:00:00.000Z",
					value: 0.90962132950276764,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T15:00:00.000Z",
					value: 1.8280086605307091,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T16:00:00.000Z",
					value: 0.82973152637058423,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T17:00:00.000Z",
					value: 0.95071880158115185,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T18:00:00.000Z",
					value: 0.98265253355582149,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T19:00:00.000Z",
					value: 0.9493100624549129,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T20:00:00.000Z",
					value: 0.84880328532205773,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T21:00:00.000Z",
					value: 0.67427280929290268,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T22:00:00.000Z",
					value: 0.85691544594331859,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-17T23:00:00.000Z",
					value: 1.7312535131929521,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T00:00:00.000Z",
					value: 0.88179920010375834,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T01:00:00.000Z",
					value: 0.83289148682423153,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T02:00:00.000Z",
					value: 0.95918758446281238,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T03:00:00.000Z",
					value: 0.98209836034042852,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T04:00:00.000Z",
					value: 0.88268097702473214,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T05:00:00.000Z",
					value: 0.81254784802867563,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T06:00:00.000Z",
					value: 0.967569333001203,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T07:00:00.000Z",
					value: 1.615326565449263,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T08:00:00.000Z",
					value: 0.20253267572182837,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T09:00:00.000Z",
					value: 0.92499539010844256,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T10:00:00.000Z",
					value: 0.68783324712274885,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T11:00:00.000Z",
					value: 0.74878779992319533,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T12:00:00.000Z",
					value: 0.971007292440452,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T13:00:00.000Z",
					value: 0.96743023451909615,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T14:00:00.000Z",
					value: 0.98498667084288927,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T15:00:00.000Z",
					value: 1.7818438983694334,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T16:00:00.000Z",
					value: 0.98799515085776357,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T17:00:00.000Z",
					value: 0.70035787974163188,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T18:00:00.000Z",
					value: 0.95085498138559887,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T19:00:00.000Z",
					value: 0.53801939387162057,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T20:00:00.000Z",
					value: 0.84071877110502968,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T21:00:00.000Z",
					value: 0.69203344627835539,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T22:00:00.000Z",
					value: 0.95804055722095727,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-18T23:00:00.000Z",
					value: 1.8064240303587802,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T00:00:00.000Z",
					value: 0.87391907629251986,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T01:00:00.000Z",
					value: 0.52829968311040088,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T02:00:00.000Z",
					value: 0.75072135571934662,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T03:00:00.000Z",
					value: 0.48692972548337354,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T04:00:00.000Z",
					value: 0.56908732602751977,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T05:00:00.000Z",
					value: 0.87353920187487266,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T06:00:00.000Z",
					value: 0.39541890171703259,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T07:00:00.000Z",
					value: 1.3184423115242239,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T08:00:00.000Z",
					value: 0.9175502042863416,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T09:00:00.000Z",
					value: 0.80637186819109385,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T10:00:00.000Z",
					value: 1.0007020468353161,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T11:00:00.000Z",
					value: 0.8588798026404918,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T12:00:00.000Z",
					value: 0.75206228685697063,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T13:00:00.000Z",
					value: 0.76617054737380341,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T14:00:00.000Z",
					value: 0.687212617465023,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T15:00:00.000Z",
					value: 1.8389983263361045,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T16:00:00.000Z",
					value: 0.836126752079385,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T17:00:00.000Z",
					value: 0.97244091466614968,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T18:00:00.000Z",
					value: 0.99785963376555042,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T19:00:00.000Z",
					value: 0.95883418357416683,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T20:00:00.000Z",
					value: 0.56872422290283908,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T21:00:00.000Z",
					value: 0.85076802671033147,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T22:00:00.000Z",
					value: 0.896980528191519,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-19T23:00:00.000Z",
					value: 1.8229185496455844,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T00:00:00.000Z",
					value: 0.95763484361404094,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T01:00:00.000Z",
					value: 0.94147029832239582,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T02:00:00.000Z",
					value: 0.88575056440279409,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T03:00:00.000Z",
					value: 0.74502826991882087,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T04:00:00.000Z",
					value: 0.56347325147091087,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T05:00:00.000Z",
					value: 0.8678386091431235,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T06:00:00.000Z",
					value: 0.90547938901828373,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T07:00:00.000Z",
					value: 1.5885582544326544,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T08:00:00.000Z",
					value: 0.96314197629299936,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T09:00:00.000Z",
					value: 0.9380476283957716,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T10:00:00.000Z",
					value: 0.98840872916780165,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T11:00:00.000Z",
					value: 0.96979556614424833,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T12:00:00.000Z",
					value: 0.9462596220906847,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T13:00:00.000Z",
					value: 0.98254929635420674,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T14:00:00.000Z",
					value: 0.88897516240042185,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T15:00:00.000Z",
					value: 1.6994175859364189,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T16:00:00.000Z",
					value: 0.92655724382324434,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T17:00:00.000Z",
					value: 0.86861247986160939,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T18:00:00.000Z",
					value: 0.9303460113044707,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T19:00:00.000Z",
					value: 0.96270235720330233,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T20:00:00.000Z",
					value: 0.9858757298152464,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T21:00:00.000Z",
					value: 0.83243238577782064,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T22:00:00.000Z",
					value: 0.93441567492569233,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-20T23:00:00.000Z",
					value: 1.4332144399069398,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T00:00:00.000Z",
					value: 0.54463390764259056,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T01:00:00.000Z",
					value: 0.97957382331766718,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T02:00:00.000Z",
					value: 0.83875294408501455,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T03:00:00.000Z",
					value: 0.95536873032500425,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T04:00:00.000Z",
					value: 0.75094056342354965,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T05:00:00.000Z",
					value: 0.96462142608039558,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T06:00:00.000Z",
					value: 0.7632679752008884,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T07:00:00.000Z",
					value: 1.4244852662790766,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T08:00:00.000Z",
					value: 0.9829323749117822,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T09:00:00.000Z",
					value: 0.95570685531343891,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T10:00:00.000Z",
					value: 0.91647167044111655,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T11:00:00.000Z",
					value: 0.86337414263238688,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T12:00:00.000Z",
					value: 0.4891986238104864,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T13:00:00.000Z",
					value: 0.98489477385159774,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T14:00:00.000Z",
					value: 0.9827114003370534,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T15:00:00.000Z",
					value: 1.5589423236419611,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T16:00:00.000Z",
					value: 0.8893481875109176,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T17:00:00.000Z",
					value: 0.83062694063310272,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T18:00:00.000Z",
					value: 0.91714530736387345,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T19:00:00.000Z",
					value: 0.7640995825862128,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T20:00:00.000Z",
					value: 0.917804326693601,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T21:00:00.000Z",
					value: 0.69419170716739387,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T22:00:00.000Z",
					value: 0.94359694035425323,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-21T23:00:00.000Z",
					value: 1.5366677220548643,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T00:00:00.000Z",
					value: 0.86444306313997121,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T01:00:00.000Z",
					value: 0.86162347674236783,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T02:00:00.000Z",
					value: 0.85274178606843043,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T03:00:00.000Z",
					value: 0.89391877300156974,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T04:00:00.000Z",
					value: 0.96012529959277026,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T05:00:00.000Z",
					value: 0.87196471624704031,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T06:00:00.000Z",
					value: 0.95787459589004054,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T07:00:00.000Z",
					value: 1.8295059864457692,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T08:00:00.000Z",
					value: 0.97624557123531719,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-05-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-06-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-07-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-08-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-09-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-10-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-11-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2026-12-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-01-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-02-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-01T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-02T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-03T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-04T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-05T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-06T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-07T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-08T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-09T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-10T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-11T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-12T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-13T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-14T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-15T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-16T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-17T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-18T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-19T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-20T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-21T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-22T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-23T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-24T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-25T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-26T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-27T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-28T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-29T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-30T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T00:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T01:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T02:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T03:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T04:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T05:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T06:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T07:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T08:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T09:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T10:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T11:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T12:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T13:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T14:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T15:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T16:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T17:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T18:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T19:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T20:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T21:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T22:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				},
				{
					name: "2027-03-31T23:00:00.000Z",
					value: 0,
					unit: "kgCO2e"
				}
			]
		}
	]
}; /* {
	title: "My running Apps - CO2e Emissions",
	lineSeries: [
		{
			name: "AWS German Cluster",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 15, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 23, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 23, unit: "kgCO2e" }
			]
		},
		{
			name: "Azure Spain Platform",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 30, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 32, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 35, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 38, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 36, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 34, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 32, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 35, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 38, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 36, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 34, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 37, unit: "kgCO2e" }
			]
		},
		{
			name: "Dummy eCommerce",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 12, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 15, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 16, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 14, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 60, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 50, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 40, unit: "kgCO2e" }
			]
		},
		{
			name: "Fatturazione",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 5, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 7, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 9, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 11, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 8, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 6, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 8, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 9, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 7, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 9, unit: "kgCO2e" }
			]
		},
		{
			name: "GCP Application",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 28, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 26, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 24, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 28, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 26, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 24, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 27, unit: "kgCO2e" }
			]
		}
	]
}; */

export const GET_APPS_WATER_CONSUMPTION_RESPONSE = {
	title: "My running Apps - Water Consumption",
	lineSeries: [
		{
			name: "AWS German Cluster",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 120, unit: "m3" },
				{ name: "2025-02-01T00:00:00Z", value: 110, unit: "m3" },
				{ name: "2025-03-01T00:00:00Z", value: 105, unit: "m3" },
				{ name: "2025-04-01T00:00:00Z", value: 100, unit: "m3" },
				{ name: "2025-05-01T00:00:00Z", value: 98, unit: "m3" },
				{ name: "2025-06-01T00:00:00Z", value: 95, unit: "m3" },
				{ name: "2025-07-01T00:00:00Z", value: 92, unit: "m3" },
				{ name: "2025-08-01T00:00:00Z", value: 90, unit: "m3" },
				{ name: "2025-09-01T00:00:00Z", value: 94, unit: "m3" },
				{ name: "2025-10-01T00:00:00Z", value: 97, unit: "m3" },
				{ name: "2025-11-01T00:00:00Z", value: 103, unit: "m3" },
				{ name: "2025-12-01T00:00:00Z", value: 110, unit: "m3" }
			]
		},
		{
			name: "Azure Spain Platform",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 140, unit: "m3" },
				{ name: "2025-02-01T00:00:00Z", value: 138, unit: "m3" },
				{ name: "2025-03-01T00:00:00Z", value: 142, unit: "m3" },
				{ name: "2025-04-01T00:00:00Z", value: 145, unit: "m3" },
				{ name: "2025-05-01T00:00:00Z", value: 147, unit: "m3" },
				{ name: "2025-06-01T00:00:00Z", value: 150, unit: "m3" },
				{ name: "2025-07-01T00:00:00Z", value: 148, unit: "m3" },
				{ name: "2025-08-01T00:00:00Z", value: 146, unit: "m3" },
				{ name: "2025-09-01T00:00:00Z", value: 149, unit: "m3" },
				{ name: "2025-10-01T00:00:00Z", value: 153, unit: "m3" },
				{ name: "2025-11-01T00:00:00Z", value: 156, unit: "m3" },
				{ name: "2025-12-01T00:00:00Z", value: 160, unit: "m3" }
			]
		},
		{
			name: "Dummy eCommerce",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 60, unit: "m3" },
				{ name: "2025-02-01T00:00:00Z", value: 58, unit: "m3" },
				{ name: "2025-03-01T00:00:00Z", value: 55, unit: "m3" },
				{ name: "2025-04-01T00:00:00Z", value: 50, unit: "m3" },
				{ name: "2025-05-01T00:00:00Z", value: 48, unit: "m3" },
				{ name: "2025-06-01T00:00:00Z", value: 45, unit: "m3" },
				{ name: "2025-07-01T00:00:00Z", value: 43, unit: "m3" },
				{ name: "2025-08-01T00:00:00Z", value: 46, unit: "m3" },
				{ name: "2025-09-01T00:00:00Z", value: 50, unit: "m3" },
				{ name: "2025-10-01T00:00:00Z", value: 52, unit: "m3" },
				{ name: "2025-11-01T00:00:00Z", value: 55, unit: "m3" },
				{ name: "2025-12-01T00:00:00Z", value: 58, unit: "m3" }
			]
		},
		{
			name: "Fatturazione",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 30, unit: "m3" },
				{ name: "2025-02-01T00:00:00Z", value: 32, unit: "m3" },
				{ name: "2025-03-01T00:00:00Z", value: 35, unit: "m3" },
				{ name: "2025-04-01T00:00:00Z", value: 34, unit: "m3" },
				{ name: "2025-05-01T00:00:00Z", value: 33, unit: "m3" },
				{ name: "2025-06-01T00:00:00Z", value: 32, unit: "m3" },
				{ name: "2025-07-01T00:00:00Z", value: 31, unit: "m3" },
				{ name: "2025-08-01T00:00:00Z", value: 30, unit: "m3" },
				{ name: "2025-09-01T00:00:00Z", value: 32, unit: "m3" },
				{ name: "2025-10-01T00:00:00Z", value: 33, unit: "m3" },
				{ name: "2025-11-01T00:00:00Z", value: 34, unit: "m3" },
				{ name: "2025-12-01T00:00:00Z", value: 35, unit: "m3" }
			]
		},
		{
			name: "GCP Application",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 90, unit: "m3" },
				{ name: "2025-02-01T00:00:00Z", value: 92, unit: "m3" },
				{ name: "2025-03-01T00:00:00Z", value: 94, unit: "m3" },
				{ name: "2025-04-01T00:00:00Z", value: 96, unit: "m3" },
				{ name: "2025-05-01T00:00:00Z", value: 95, unit: "m3" },
				{ name: "2025-06-01T00:00:00Z", value: 93, unit: "m3" },
				{ name: "2025-07-01T00:00:00Z", value: 92, unit: "m3" },
				{ name: "2025-08-01T00:00:00Z", value: 91, unit: "m3" },
				{ name: "2025-09-01T00:00:00Z", value: 93, unit: "m3" },
				{ name: "2025-10-01T00:00:00Z", value: 95, unit: "m3" },
				{ name: "2025-11-01T00:00:00Z", value: 98, unit: "m3" },
				{ name: "2025-12-01T00:00:00Z", value: 100, unit: "m3" }
			]
		}
	]
};

export const GET_TOTAL_CO2_RESPONSE = {
	value: 5.12754328952,
	unit: "CO2 kgCo2e"
};

export const GET_TOTAL_EMISSIONS_RESPONSE = {
	months: [
		{ month: "2026-01", scope2: 1.2, scope3: 0.9, unit: "tCO2e" },
		{ month: "2026-02", scope2: 1.4, scope3: 1.1, unit: "tCO2e" },
		{ month: "2026-03", scope2: 1.6, scope3: 1.2, unit: "tCO2e" }
	]
};

export const GET_EXPORT_CSV_RESPONSE = "Y29sMSxjb2wyCnZhbHVlMSx2YWx1ZTI=";

export const GET_EXPORT_MANIFEST_RESPONSE = "dmVyc2lvbjogMQo=";

export const GET_EXPORT_REPORT_RESPONSE =
	"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";

export const GET_ENVIRONMENTAL_IMPACT_BY_APPLICATION_RESPONSE = {
	totalEmission: 804.084,
	first: true,
	last: true,
	size: 20,
	totalElements: 4,
	totalPages: 1,
	number: 0,
	contents: [
		{
			application: "Jumbo German Machine Learning Application",
			numberOfLayers: 5,
			totalEmissions: 730.5
		},
		{ application: "Azure Data", numberOfLayers: 3, totalEmissions: 42.3 },
		{ application: "Customer Portal", numberOfLayers: 4, totalEmissions: 18.7 },
		{ application: "Finance Automation", numberOfLayers: 2, totalEmissions: 12.584 }
	]
};
